import React, {useState} from 'react'
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";


// components
import {getStateByPath} from "../../../../redux/selectors";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {GenericButton} from "../../../../components/buttons/customButtons";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {widgetIconService} from "../../../../jwt/_services/landings/widgetIconService";

// providers
import {iconProvider} from "../../../../providers/landings/iconProvider";

const LinkedIcon = props => {
    const path = `${props.path}/icons`;

    const pageState = useSelector(state => getStateByPath(state, props.path));
    const {app, domainObject: widget} = pageState?.data || {};
    const {fbDataBase} = app

    const [icon, setIcon] = useState(null)

    const handleLinked = () => {
        if(!icon) return;

        const requestData = {
            fbDataBase,
            item:{
                widget: {id: widget?.id},
                icon: {id: icon}
            }
        }

        genericIndexedActions.save(path, widgetIconService, requestData, resetLabel)
    }

    const resetLabel = () => setIcon(null)


    return <Row className={'mb-2em'}>
        <Col sm={9}>
            <SelectGeneric
                title={'Icono'}
                showSpinner={false}
                initialValue={icon}
                setExternalValue={setIcon}
                provider={iconProvider}
            />
        </Col>
        <Col>
            <div className={'pt-2em pull-left'}>
                <GenericButton
                    clazz={'mt-2em'}
                    style={'table'}
                    label={'Vincular'}
                    toolTip={'Agregar icono'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={handleLinked}
                />
            </div>
        </Col>
    </Row>
}
export default LinkedIcon;